import findScriptEntities from './findScriptEntities';
import Script from './Script';

const createScriptDecorator = () => ({
    strategy: findScriptEntities,
    component: Script
});

export default createScriptDecorator;
